import React from 'react';
import { bonuses } from '../data/bonuses';
import { BonusArt } from './BonusArt';
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="w-full bg-light" data-id="element-38" data-mp="pio86ksqx080">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-39" data-mp="avl8c7gyafhi">
        <div className="text-center" data-id="element-40" data-mp="at8vg8q1uvbb">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-court" data-id="element-41" data-mp="ftegv75q7lky">
            Also included at no extra cost
          </p>
          <h2 id="bonuses-heading" className="mt-3 font-display font-bold text-ink text-[28px] leading-tight tracking-tight sm:text-5xl" data-id="element-42" data-mp="1t3ou0sok0y7">
            Five instant-use <span className="text-court" data-id="element-43" data-mp="3o36bwmv8bejy">bonuses</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-ink-soft" data-id="element-44" data-mp="3szwqt6vas43s">
            The volumes give you the season. These five get you ready for your
            very next session.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-45" data-mp="1r8a1rauyuj9y">
          {bonuses.map((bonus, i) => <article key={bonus.number} className={`flex flex-col overflow-hidden rounded-2xl border border-line bg-white shadow-card ${i === bonuses.length - 1 ? 'sm:col-span-2 sm:mx-auto sm:w-[calc(50%-8px)]' : ''}`} data-id="element-46" data-mp="3iden48rps86g" data-mpi={i}>
              {bonus.cover ? <img src={bonus.cover} alt={`${bonus.title} cover`} width={1024} height={1024} loading="lazy" className="h-[230px] w-full border-b border-line object-cover sm:h-[265px]" data-id="element-47" data-mp="2zfanc4xpvlhb" /> : <BonusArt number={bonus.number} title={bonus.title} index={i} data-id="element-48" data-mp="33g49asrlmq7k" />}
              <div className="px-5 pb-6 pt-4" data-id="element-49" data-mp="np004uox2gap">
                <div className="flex flex-wrap items-center gap-2" data-id="element-50" data-mp="nruk6l40pz3l">
                  <span className="text-[11px] font-bold uppercase tracking-widest text-ink-muted" data-id="element-51" data-mp="iqeycqu0nok5">
                    Bonus {bonus.number}
                  </span>
                  <span className="rounded bg-green px-2 py-1 text-[10px] font-bold uppercase tracking-wider text-white" data-id="element-52" data-mp="3hhhpukombv5h">
                    Free today
                  </span>
                </div>
                <h3 className="mt-2.5 font-display text-lg font-bold leading-snug text-ink" data-id="element-53" data-mp="3qj7ghoaoeq27">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-sm text-ink-soft" data-id="element-54" data-mp="2tu9m476u8u5k">{bonus.body}</p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}